import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe  from 'photoswipe'

/**
 * Идентификатор HTML элемента.
 */
const galleryElement = 'ps-gallery'

/**
 * Initializes a PhotoSwipe lightbox for the ps gallery.
 *
 * Здесь может быть любая необходимая логика.
 *
 * Экспорт функции инициализации дает возможность
 * контроля, когда и как подключать.
 *
 * @returns {PhotoSwipeLightbox | null} The created lightbox instance, or null if not initialized.
 */
export function createPsGallery(): PhotoSwipeLightbox | null {
  if (typeof document === 'undefined') return null

  const root = document.getElementById(galleryElement)
  if (!root) {
    console.warn(`Корневой элемент не найден #${galleryElement}`)
    return null
  }

  const gallery = new PhotoSwipeLightbox({
    gallery: `#${galleryElement}`,
    children: 'a',
    pswpModule: PhotoSwipe,
  })

  gallery.init()
  return gallery
}
